module.exports = __webpack_public_path__ + "static/media/sample_bulk_upload_prt_consignment_data.2136ebdd.csv";